import { BRAND_NAME } from "@ide/shared";
import { cn } from "@/lib/utils";

/** Proporção do símbolo oficial (largura / altura): apps/desktop/scripts/gerar-icones.py. */
const MARK_RATIO = 512 / 252;

/**
 * Símbolo oficial do Kompil (a fita em laço com o ponto). Sem fundo: branco no tema escuro, preto
 * no claro. `size` é a altura em px.
 */
export function LogoMark({ size = 22, className }: { size?: number; className?: string }) {
  const width = Math.round(size * MARK_RATIO);
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex shrink-0 items-center", className)}
      style={{ width, height: size }}
    >
      <img
        src="/brand/mark-white.png"
        alt=""
        width={width}
        height={size}
        draggable={false}
        className="hidden select-none dark:block"
      />
      <img
        src="/brand/mark-black.png"
        alt=""
        width={width}
        height={size}
        draggable={false}
        className="block select-none dark:hidden"
      />
    </span>
  );
}

/** Ícone do app (ladrilho preto com o símbolo): telas de entrada e avatares de sistema. */
export function LogoIcon({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <img
      src={size > 128 ? "/brand/icon-512.png" : size > 48 ? "/brand/icon-256.png" : "/brand/icon-128.png"}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      draggable={false}
      className={cn("shrink-0 select-none rounded-[22%] ring-1 ring-white/10", className)}
    />
  );
}

export function Logo({ className }: { className?: string }) {
  // `||`: variável definida porém vazia (ex.: build-arg omitido no Docker) também cai no padrão.
  const brand = (import.meta.env.VITE_BRAND_NAME as string | undefined) || BRAND_NAME;
  return (
    <span className={cn("inline-flex items-center gap-2 font-semibold tracking-tight text-fg", className)}>
      <LogoMark size={18} />
      <span className="text-[15px] font-semibold tracking-[-0.01em]">{brand}</span>
    </span>
  );
}
